import Swal from 'sweetalert2'
import ClipboardJS from 'clipboard'
import { lang } from '@/store'
import { get } from 'svelte/store'

export function i18n(lang: string, stringArr: string[]): string {
  if (stringArr.length === 1) return stringArr[0]
  const index = lang === 'lo' ? 1 : 0
  return stringArr[index]
}

export function showErrorMessage(message: string): void {
  Swal.fire({
    icon: 'error',
    text: message,
    showConfirmButton: false,
    timer: 8000,
    timerProgressBar: true,
    confirmButtonColor: '#1CAAFC',
  })
}

export function initClipboard() {
  const clipboard = new ClipboardJS('.js-clipboard')

  clipboard.on('success', (e) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'center',
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: false,
      width: '240px',
    })
    Toast.fire({
      icon: 'success',
      title: i18n(get(lang), ['Copied', 'ກ໋ອບປີ້ສຳເລັດ']),
    })
  })

  clipboard.on('error', (e) => {
    console.error('Clipboard Error', e)
  })
}

export function openDeeplink(url: string): void {
  try {
    // @ts-ignore
    window.flutter_inappwebview.callHandler('openDeepLink', url)
  } catch (error) {
    console.error('Cannot open deeplink', url)
    window.open(url, '_blank')
  }
}

export function formatNumber(num: number, decimal: number | undefined = undefined): string {
  if (decimal === undefined) {
    return num.toLocaleString('en-US')
  }

  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal,
  })
}

// Service Constants
export const SERVICE_EXTERNAL_LOAN = "EXTERNAL LOAN"
